import React, { Fragment } from 'react'
import { NumericFormat } from 'react-number-format'
import DateView from 'components/formatter/DateView'
import ItemInput from 'components/form-elements/ItemInput'

const DetailDataTableCell = (props) => {
    let { val, coltype, colname, item, label, setValue, register,
        errors, handleSubmit, watch, control, idx, detailkey, defaultValue, ...rest } = props
    const dtype = coltype?.dtype ? coltype?.dtype : coltype?.type
    const renderFunc = coltype?.iRenderFunc
    if (renderFunc) {
        return renderFunc(val, colname, item, coltype, idx)
    } else {
        let { label, colsize, name, ...element } = coltype
        const iname = detailkey + "." + idx + "." + name
        if (defaultValue) {
            element.defaultValue = defaultValue
        }
        let valview = <>
            <ItemInput
                label={""}
                labelinput={label}
                elname={colname}
                name={iname}
                colsize={12}
                {...element}
                setValue={setValue}
                register={register}
                handleSubmit={handleSubmit}
                watch={watch}
                errors={errors}
                control={control}
                key={"input-item" + idx}
                idx={idx}
                mb={"0"}
                margin={"mb-0"}
            />
        </>

        if (colname === "no" || colname === "iaction") {
            valview = ""
        }
        return (
            <Fragment>{element && valview}</Fragment>
        )
    }
}

DetailDataTableCell.defaultProps = {
    val: null,
    ctype: null,
    colname: null,
    item: null
}

export default DetailDataTableCell
